import React, { Component, Fragment } from 'react'
import VehicleDetails from '.';
import {
	VEHICLE_TYPE
} from 'utils/constants';
import './VehicleDetails.scss';

class VehicleDetailsAbout extends Component {
    renderAboutInformation() {
        return (
            <Fragment>
                <div className="VehicleDetails__more-items">
                    <h2 className="VehicleDetails__more-items__title">Sobre {this.props.vehicleType == VEHICLE_TYPE.car ? 'este carro' : 'esta moto'}</h2>
                </div>
                <p id={'VehicleAboutInformationDescription'} className="VehicleDetails__container__description-about">{this.props.longComment}</p>
            </Fragment>
        )
    }
    render() {
        return (
            this.props.longComment ?
                <VehicleDetails className={this.props.className ? this.props.className : ''} id={this.props.id ? this.props.id : ''} title={this.props.title ? this.props.title : ''}>
                    {this.renderAboutInformation()}
                </VehicleDetails>
                : null
        )
    }
}
export default VehicleDetailsAbout